// extracted by mini-css-extract-plugin
export default {"shipping":"mi-z","header":"ni-z","adjustMarginAndPaddingNewDesign":"oi-z"};